// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xwE0MFOnfuyPr4AGQ4pG {
	font-family: 'Cygnito Mono', monospace;
	font-weight: 400;
	word-break: break-word;
	margin: 0;

	/* Size */
}
.xwE0MFOnfuyPr4AGQ4pG._nPsxGgR8mecMSeX2G_j {
		font-size: 40px;
		line-height: 64px;
	}
@media (max-width: 767px) {
	.xwE0MFOnfuyPr4AGQ4pG._nPsxGgR8mecMSeX2G_j {
			font-size: 28px;
			line-height: 36px;
	}
		}
.xwE0MFOnfuyPr4AGQ4pG.w0dhntDOKrUM1tENAUvj {
		font-size: 28px;
		line-height: 28px;
	}
.xwE0MFOnfuyPr4AGQ4pG.KUJfMlydlWF4m5oDm2fl {
		font-size: 20px;
		line-height: 28px;
	}
.xwE0MFOnfuyPr4AGQ4pG.t7CHuUC6fRetIDNdCUff {
		font-size: 16px;
		line-height: 24px;
	}
@media (max-width: 767px) {
	.xwE0MFOnfuyPr4AGQ4pG.t7CHuUC6fRetIDNdCUff {
			font-size: 12px;
			line-height: 18px;
	}
		}
.xwE0MFOnfuyPr4AGQ4pG.B9fSJBd81VvNMqSiq8Xa {
		font-size: 14px;
		line-height: 28px;
	}
.xwE0MFOnfuyPr4AGQ4pG.aX56uqeGYD3JpojprV4Q {
		font-size: 12px;
		line-height: 20px;
	}

/* Colors */
.xwE0MFOnfuyPr4AGQ4pG.B_8uUN3dTwQZpVbnnqXa {
		color: var(--black);
	}
.xwE0MFOnfuyPr4AGQ4pG.LXPUI1ihwSIbBWwLpCVS {
		color: var(--white);
	}
.xwE0MFOnfuyPr4AGQ4pG.ZqhRZOmrk0ehr_AmmRDT {
		color: var(--gray3);
	}
.xwE0MFOnfuyPr4AGQ4pG.r7HHhlVXqHy5O7mre97G {
		color: var(--green);
	}
.xwE0MFOnfuyPr4AGQ4pG.SrBAIIclNXKNasLHTgsn {
		color: inherit;
	}

/* Align */
.xwE0MFOnfuyPr4AGQ4pG.bm5MChOsa_Mmf8DthZFd {
		text-align: left;
	}
.xwE0MFOnfuyPr4AGQ4pG.LVdSuem9ReDf7JD0dyu3 {
		text-align: center;
	}
.xwE0MFOnfuyPr4AGQ4pG.Z3nGOh1dkCtlb1_vFg8w {
		text-align: right;
	}

/* Display */
.xwE0MFOnfuyPr4AGQ4pG.Wi5lWUAmxpSpdo1gnh4w {
		white-space: nowrap;
	}
`, "",{"version":3,"sources":["webpack://./src/components/Typography/Typography.pcss"],"names":[],"mappings":"AAEA;CACC,sCAAsC;CACtC,gBAAgB;CAChB,sBAAsB;CACtB,SAAS;;CAET,SAAS;AA+EV;AA9EC;EACC,eAAe;EACf,iBAAiB;CAMlB;AAJC;CAJD;GAKE,eAAe;GACf,iBAAiB;CAEnB;EADC;AAGD;EACC,eAAe;EACf,iBAAiB;CAClB;AAEA;EACC,eAAe;EACf,iBAAiB;CAClB;AAEA;EACC,eAAe;EACf,iBAAiB;CAMlB;AAJC;CAJD;GAKE,eAAe;GACf,iBAAiB;CAEnB;EADC;AAGD;EACC,eAAe;EACf,iBAAiB;CAClB;AAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;AAEA,WAAW;AACX;EACC,mBAAmB;CACpB;AAEA;EACC,mBAAmB;CACpB;AAEA;EACC,mBAAmB;CACpB;AAEA;EACC,mBAAmB;CACpB;AAEA;EACC,cAAc;CACf;;AAEA,UAAU;AACV;EACC,gBAAgB;CACjB;AAEA;EACC,kBAAkB;CACnB;AAEA;EACC,iBAAiB;CAClB;;AAEA,YAAY;AACZ;EACC,mBAAmB;CACpB","sourcesContent":["@import './../../stylesheets/media-queries.pcss';\n\n.typography {\n\tfont-family: 'Cygnito Mono', monospace;\n\tfont-weight: 400;\n\tword-break: break-word;\n\tmargin: 0;\n\n\t/* Size */\n\t&.size-XXL {\n\t\tfont-size: 40px;\n\t\tline-height: 64px;\n\n\t\t@media (--mobile) {\n\t\t\tfont-size: 28px;\n\t\t\tline-height: 36px;\n\t\t}\n\t}\n\n\t&.size-XL {\n\t\tfont-size: 28px;\n\t\tline-height: 28px;\n\t}\n\n\t&.size-L {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t}\n\n\t&.size-M {\n\t\tfont-size: 16px;\n\t\tline-height: 24px;\n\n\t\t@media (--mobile) {\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 18px;\n\t\t}\n\t}\n\n\t&.size-S {\n\t\tfont-size: 14px;\n\t\tline-height: 28px;\n\t}\n\n\t&.size-XS {\n\t\tfont-size: 12px;\n\t\tline-height: 20px;\n\t}\n\n\t/* Colors */\n\t&.color-black {\n\t\tcolor: var(--black);\n\t}\n\n\t&.color-white {\n\t\tcolor: var(--white);\n\t}\n\n\t&.color-gray {\n\t\tcolor: var(--gray3);\n\t}\n\n\t&.color-green {\n\t\tcolor: var(--green);\n\t}\n\n\t&.color-inherit {\n\t\tcolor: inherit;\n\t}\n\n\t/* Align */\n\t&.align-left {\n\t\ttext-align: left;\n\t}\n\n\t&.align-center {\n\t\ttext-align: center;\n\t}\n\n\t&.align-right {\n\t\ttext-align: right;\n\t}\n\n\t/* Display */\n\t&.nowrap {\n\t\twhite-space: nowrap;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"typography": `xwE0MFOnfuyPr4AGQ4pG`,
	"size-XXL": `_nPsxGgR8mecMSeX2G_j`,
	"sizeXxl": `_nPsxGgR8mecMSeX2G_j`,
	"size-XL": `w0dhntDOKrUM1tENAUvj`,
	"sizeXl": `w0dhntDOKrUM1tENAUvj`,
	"size-L": `KUJfMlydlWF4m5oDm2fl`,
	"sizeL": `KUJfMlydlWF4m5oDm2fl`,
	"size-M": `t7CHuUC6fRetIDNdCUff`,
	"sizeM": `t7CHuUC6fRetIDNdCUff`,
	"size-S": `B9fSJBd81VvNMqSiq8Xa`,
	"sizeS": `B9fSJBd81VvNMqSiq8Xa`,
	"size-XS": `aX56uqeGYD3JpojprV4Q`,
	"sizeXs": `aX56uqeGYD3JpojprV4Q`,
	"color-black": `B_8uUN3dTwQZpVbnnqXa`,
	"colorBlack": `B_8uUN3dTwQZpVbnnqXa`,
	"color-white": `LXPUI1ihwSIbBWwLpCVS`,
	"colorWhite": `LXPUI1ihwSIbBWwLpCVS`,
	"color-gray": `ZqhRZOmrk0ehr_AmmRDT`,
	"colorGray": `ZqhRZOmrk0ehr_AmmRDT`,
	"color-green": `r7HHhlVXqHy5O7mre97G`,
	"colorGreen": `r7HHhlVXqHy5O7mre97G`,
	"color-inherit": `SrBAIIclNXKNasLHTgsn`,
	"colorInherit": `SrBAIIclNXKNasLHTgsn`,
	"align-left": `bm5MChOsa_Mmf8DthZFd`,
	"alignLeft": `bm5MChOsa_Mmf8DthZFd`,
	"align-center": `LVdSuem9ReDf7JD0dyu3`,
	"alignCenter": `LVdSuem9ReDf7JD0dyu3`,
	"align-right": `Z3nGOh1dkCtlb1_vFg8w`,
	"alignRight": `Z3nGOh1dkCtlb1_vFg8w`,
	"nowrap": `Wi5lWUAmxpSpdo1gnh4w`
};
export default ___CSS_LOADER_EXPORT___;
